<template>
    <Panel title="组件配置">
        <el-form ref="form" :model="value" label-position="top">
            <el-row>
                <el-col :span='12'>
                    <el-form-item label="密码" required>
                        <el-input v-model="value.ukeyPassword"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </Panel>
</template>

<script>
export default {
    props: {
        // ukeyPassword;
        // deviceName = "USBKey";
        // hostId;
        value: Object
    },
    methods: {
        validate() {
            return this.$refs.form.validate();
        },
    }

}
</script>

<style scoped>

</style>